export default import.meta.ROLLDOWN_FILE_URL_u61pO5yVFn0KK6Xem8szdw